const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: '6b3cfd1c595cc8994c09d12fa15da5e5',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
    vidsrc: {
        baseUrl: 'https://vidsrc.mov/',
        // Subtitle manifest, served as JSON: [{"file": "sub_en.vtt", "label": "English"}].
        // The player reads it through ?sub.info={manifest_url}.
        // Left null on purpose: VidSrc's embed route drops the media id whenever a
        // query string is present, so this stays off until the player accepts it.
        subtitlesUrl: null
    }
}

export default apiConfig;